import React from "react";
import "./Stats.css";
import useScrollReveal from "../hooks/useScrollReveal";

const stats = [
  { metric: "10+", label: "Projects delivered from concept to production" },
  { metric: "99.9%", label: "Uptime across client infrastructure" },
  { metric: "15+", label: "Cloud & development technologies" },
  { metric: "50%", label: "Faster time-to-market with our frameworks" },
];

export default function Stats() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="stats reveal">
      <div className="stats-label">Com2Cloud in Numbers</div>
      <div className="stats-grid">
        {stats.map((stat, idx) => (
          <div className={`stat-card reveal-delay-${idx + 1}`} key={idx}>
            <span className="stat-metric">{stat.metric}</span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
